import React, { useEffect } from 'react';

import { useAppDispatch } from '../../app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from '../../features/ui/model/uiSlice';
import { CompetitionsListWidget } from '../../widgets/competitions-b2cr/list';

const CompetitonsB2CRPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Соревнования B2CR'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать соревнование'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CompetitionsListWidget />;
};

export { CompetitonsB2CRPage };
